module.exports = __webpack_public_path__ + "static/media/w1.28a5b41e.png";